<template>
  <div class="justify-content-center mb-5" id="esgContainer">

    <div class="row justify-content-center mt-5">
      <div class="row" style="font: normal normal bold 1.3em Segoe UI;color: #FFFFFF;">
        Les chances de perte en capital sont :
      </div>
      <div class="row justify-content-center mt-4">
        <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Scénario 1 - perte de 5%
              <!-- <span v-b-modal="'my_modal_scope1' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scope1' + this.uid" centered hide-footer title="Scope 1">
                <p class="my-4">Le Scope 1 comprend les émissions de gaz à effet de serre directement liées à la fabrication des produits. Par exemple, si la fabrication d'un produit nécessite l'utilisation de pétrole, la combustion de carburant, ou si la production du produit génère des émissions de CO2 ou de méthane, toutes ces émissions sont incluses dans le scope 1. C'est ce qu'on appelle les émissions directes.</p>
              </b-modal> -->
            </div>
            <div class="last">Probabilité de perdre plus de 5% sur 21 jours (1 mois)</div>
            <div class="nb">{{ Math.round(risks.P_21_005*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_21_005*10000)/100 }} %</div>
            <div class="last">Probabilité de perdre plus de 5% sur 42 jours (2 mois)</div>
            <div class="nb">{{ Math.round(risks.P_42_005*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_42_005*10000)/100 }} %</div>
            <div class="last">Probabilité de perdre plus de 5% sur 63 jours (3 mois)</div>
            <div class="nb">{{ Math.round(risks.P_63_005*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_63_005*10000)/100 }} %</div>
          </div>
        </div>
         <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Scénario 2 - perte de 10 %
              <!-- <span v-b-modal="'my_modal_scope1' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scope1' + this.uid" centered hide-footer title="Scope 1">
                <p class="my-4">Le Scope 1 comprend les émissions de gaz à effet de serre directement liées à la fabrication des produits. Par exemple, si la fabrication d'un produit nécessite l'utilisation de pétrole, la combustion de carburant, ou si la production du produit génère des émissions de CO2 ou de méthane, toutes ces émissions sont incluses dans le scope 1. C'est ce qu'on appelle les émissions directes.</p>
              </b-modal> -->
            </div>
            <div class="last">Probabilité de perdre plus de 10% sur 21 jours (1 mois)</div>
            <div class="nb">{{ Math.round(risks.P_21_01*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_21_01*10000)/100 }} %</div>
            <div class="last">Probabilité de perdre plus de 10% sur 42 jours (2 mois)</div>
            <div class="nb">{{ Math.round(risks.P_42_01*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_42_01*10000)/100 }} %</div>
            <div class="last">Probabilité de perdre plus de 10% sur 63 jours (3 mois)</div>
            <div class="nb">{{ Math.round(risks.P_63_01*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_63_01*10000)/100 }} %</div>
          </div>
        </div>
         <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Scénario 3 - perte de 15 %
              <!-- <span v-b-modal="'my_modal_scope1' + this.uid"><b-icon-info-circle style="font-size:20px"/></span>
              <b-modal modal-class="mf_modal_bl" size="xl" :id="'my_modal_scope1' + this.uid" centered hide-footer title="Scope 1">
                <p class="my-4">Le Scope 1 comprend les émissions de gaz à effet de serre directement liées à la fabrication des produits. Par exemple, si la fabrication d'un produit nécessite l'utilisation de pétrole, la combustion de carburant, ou si la production du produit génère des émissions de CO2 ou de méthane, toutes ces émissions sont incluses dans le scope 1. C'est ce qu'on appelle les émissions directes.</p>
              </b-modal> -->
            </div>
            <div class="last">Probabilité de perdre plus de 15% sur 21 jours (1 mois)</div>
            <div class="nb">{{ Math.round(risks.P_21_015*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_21_015*10000)/100 }} %</div>
            <div class="last">Probabilité de perdre plus de 15% sur 42 jours (2 mois)</div>
            <div class="nb">{{ Math.round(risks.P_21_015*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_21_015*10000)/100 }} %</div>
            <div class="last">Probabilité de perdre plus de 15% sur 63 jours (2 mois)</div>
            <div class="nb">{{ Math.round(risks.P_21_015*10000)/100 }} %</div>
            <div class="last">Valeur moyenne de la perte si cet événement se produit</div>
            <div class="nb">{{ Math.round(risks.Cvarn_21_015*10000)/100 }} %</div>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div class="esgCard mf_card_bl m-1">
            <div class="first">
              Volatilité actuelle:
            </div>
            <div class="nb">{{ formatEuros(risks.volatility) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["risks", "accessgranted", "token", "route"],
  data() {
    return {
      access: "",
      show: false,
      variants: ["primary", "secondary", "success", "warning", "danger", "info", "light", "dark"],
      headerBgVariant: "info",
      headerTextVariant: "light",
      bodyBgVariant: "dark",
      bodyTextVariant: "dark",
      footerBgVariant: "info",
      footerTextVariant: "dark",
    };
  },

  mounted() {
    this.access = this.accessgranted;
  },

  methods: {
    modalId(i) {
      return "modal" + i;
    },
    formatEuros(number)
    {
      return this.$utils.numberWithSpaces(Number(number).toFixed(0));
    },
  },
};
</script>
<style lang="scss">
@import "../../../sass/_variables.scss";

#esgContainer {
  .esgCard {
    min-height: 150px;

    .first {
      text-align: center;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-evenly;
    }
    .nb {
      $mrg: 10px;
      text-align: center;
      font: normal normal bold $mf_ft_size_subtitle Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
      margin-top: $mrg;
      margin-bottom: $mrg;
    }
    .last {
      text-align: center;
      font: normal normal normal $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: $mf_ft_color_white;
      opacity: 1;
    }
  }
  #ltf-table {
    $thRadius: 20px;
    margin-top: 20px;
    margin-bottom: 0rem !important;

    .tbHeader {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      .tbHeader_label {
        margin-right: 15px;
      }
    }

    .table thead th {
      vertical-align: bottom;
      border: none;
    }
    thead {
      background: transparent;
    }
    tbody {
      border-radius: 20px;
      background: #242527;
    }
    th {
      background-color: #242527;
      border-bottom: 2px solid black;
      color: #f5f5f5;
      text-align: center;
      padding: 15px;
    }
    th:first-child {
      border-top-left-radius: $thRadius;
    }

    th:last-child {
      border-top-right-radius: $thRadius;
    }

    tr {
      text-align: center;
      font: normal normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: #cacaca;
      opacity: 1;
    }
    tr:not(:first-child) {
      border-top: 2px solid black;
    }

    td {
      border: none;
      padding: 10px;
    }

    li > span {
      position: relative;
      display: block;
      padding: 0.5rem 0.75rem;
      margin-left: -1px;
      line-height: 1.25;
      color: black;
      background-color: transparent !important;
      border: none !important;
      cursor: pointer;
      font-size: 20px !important;
      font-weight: bold !important;
    }
  }
}
</style>
